module.exports = __webpack_public_path__ + "img/aboutimgfive.5ed6fc59.png";